import { extendTailwindMerge, twMerge } from "tailwind-merge";
var y = /\s+/g, a = (e) => typeof e != "string" || !e ? e : e.replace(y, " ").trim(), u = (...e) => {
	let t = [], n = (e) => {
		if (!e && e !== 0 && e !== 0n) return;
		if (Array.isArray(e)) {
			for (let t = 0, r = e.length; t < r; t++) n(e[t]);
			return;
		}
		let r = typeof e;
		if (r === "string" || r === "number" || r === "bigint") {
			if (r === "number" && e !== e) return;
			t.push(String(e));
		} else if (r === "object") {
			let n = Object.keys(e);
			for (let r = 0, i = n.length; r < i; r++) {
				let i = n[r];
				e[i] && t.push(i);
			}
		}
	};
	for (let t = 0, r = e.length; t < r; t++) {
		let r = e[t];
		r != null && n(r);
	}
	return t.length > 0 ? a(t.join(" ")) : void 0;
}, h = (e) => e === !1 ? "false" : e === !0 ? "true" : e === 0 ? "0" : e, x = (e) => {
	if (!e || typeof e != "object") return !0;
	for (let t in e) return !1;
	return !0;
}, k = (e, t) => {
	if (e === t) return !0;
	if (!e || !t) return !1;
	let n = Object.keys(e), r = Object.keys(t);
	if (n.length !== r.length) return !1;
	for (let i = 0; i < n.length; i++) {
		let o = n[i];
		if (!r.includes(o) || e[o] !== t[o]) return !1;
	}
	return !0;
}, d = (e, t) => {
	for (let n in t) if (Object.prototype.hasOwnProperty.call(t, n)) {
		let r = t[n];
		n in e ? e[n] = u(e[n], r) : e[n] = r;
	}
	return e;
}, c = (e, t) => {
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		Array.isArray(r) ? c(r, t) : r && t.push(r);
	}
}, g = (...e) => {
	let t = [];
	c(e, t);
	let n = [];
	for (let e = 0; e < t.length; e++) t[e] && n.push(t[e]);
	return n;
}, p = (e, t) => {
	let n = {};
	for (let r in e) {
		let i = e[r];
		if (r in t) {
			let e = t[r];
			Array.isArray(i) || Array.isArray(e) ? n[r] = g(e, i) : typeof i == "object" && typeof e == "object" && i && e ? n[r] = p(i, e) : n[r] = e + " " + i;
		} else n[r] = i;
	}
	for (let r in t) r in e || (n[r] = t[r]);
	return n;
}, Q = {
	twMerge: !0,
	twMergeConfig: {},
	responsiveVariants: !1
};
function ne() {
	let e = null, t = {}, n = !1;
	return {
		get cachedTwMerge() {
			return e;
		},
		set cachedTwMerge(t) {
			e = t;
		},
		get cachedTwMergeConfig() {
			return t;
		},
		set cachedTwMergeConfig(e) {
			t = e;
		},
		get didTwMergeConfigChange() {
			return n;
		},
		set didTwMergeConfigChange(e) {
			n = e;
		},
		reset() {
			e = null, t = {}, n = !1;
		}
	};
}
var S = ne(), le = (e) => {
	let t = (t, n) => {
		let { extend: _ = null, slots: E = {}, variants: O = {}, compoundVariants: A = [], compoundSlots: j = [], defaultVariants: M = {} } = t, N = {
			...Q,
			...n
		}, P = _?.base ? u(_.base, t?.base) : t?.base, F = _?.variants && !x(_.variants) ? p(O, _.variants) : O, I = _?.defaultVariants && !x(_.defaultVariants) ? {
			..._.defaultVariants,
			...M
		} : M;
		!x(N.twMergeConfig) && !k(N.twMergeConfig, S.cachedTwMergeConfig) && (S.didTwMergeConfigChange = !0, S.cachedTwMergeConfig = N.twMergeConfig);
		let L = x(_?.slots), R = x(E) ? {} : {
			base: u(t?.base, L && _?.base),
			...E
		}, z = L ? R : d({ ..._?.slots }, x(R) ? { base: t?.base } : R), B = x(_?.compoundVariants) ? A : g(_?.compoundVariants, A), V = (t) => {
			if (x(F) && x(E) && L) return e(P, t?.class, t?.className)(N);
			if (B && !Array.isArray(B)) throw TypeError(`The "compoundVariants" prop must be an array. Received: ${typeof B}`);
			if (j && !Array.isArray(j)) throw TypeError(`The "compoundSlots" prop must be an array. Received: ${typeof j}`);
			let n = (e, t, n = [], i) => {
				let o = n;
				if (typeof t == "string") {
					let n = a(t).split(" ");
					for (let t = 0; t < n.length; t++) o.push(`${e}:${n[t]}`);
				} else if (Array.isArray(t)) for (let n = 0; n < t.length; n++) o.push(`${e}:${t[n]}`);
				else if (typeof t == "object" && typeof i == "string" && i in t) {
					let n = t[i];
					if (n && typeof n == "string") {
						let t = a(n).split(" "), s = [];
						for (let n = 0; n < t.length; n++) s.push(`${e}:${t[n]}`);
						o[i] = o[i] ? o[i].concat(s) : s;
					} else if (Array.isArray(n) && n.length > 0) {
						let t = [];
						for (let r = 0; r < n.length; r++) t.push(`${e}:${n[r]}`);
						o[i] = t;
					}
				}
				return o;
			}, i = (e, r = F, i = null, l = null) => {
				let _ = r[e];
				if (!_ || x(_)) return null;
				let v = l?.[e] ?? t?.[e];
				if (v === null) return null;
				let b = h(v), w = Array.isArray(N.responsiveVariants) && N.responsiveVariants.length > 0 || N.responsiveVariants === !0, E = I?.[e], D = [];
				if (typeof b == "object" && w) for (let [e, t] of Object.entries(b)) {
					let r = _[t];
					if (e === "initial") {
						E = t;
						continue;
					}
					Array.isArray(N.responsiveVariants) && !N.responsiveVariants.includes(e) || (D = n(e, r, D, i));
				}
				let O = _[(b != null && typeof b != "object" ? b : h(E)) || "false"];
				return typeof D == "object" && typeof i == "string" && D[i] ? d(D, O) : D.length > 0 ? (D.push(O), i === "base" ? D.join(" ") : D) : O;
			}, l = () => {
				if (!F) return null;
				let e = Object.keys(F), t = [];
				for (let n = 0; n < e.length; n++) {
					let r = i(e[n], F);
					r && t.push(r);
				}
				return t;
			}, _ = (e, t) => {
				if (!F || typeof F != "object") return null;
				let n = [];
				for (let r in F) {
					let o = i(r, F, e, t), s = e === "base" && typeof o == "string" ? o : o && o[e];
					s && n.push(s);
				}
				return n;
			}, v = {};
			for (let e in t) {
				let n = t[e];
				n !== void 0 && (v[e] = n);
			}
			let b = (e, n) => {
				let r = typeof t?.[e] == "object" ? { [e]: t[e]?.initial } : {};
				return {
					...I,
					...v,
					...r,
					...n
				};
			}, w = (e = [], t) => {
				let n = [], r = e.length;
				for (let i = 0; i < r; i++) {
					let { class: r, className: o,...s } = e[i], l = !0, m = b(null, t);
					for (let e in s) {
						let t = s[e], n = m[e];
						if (Array.isArray(t)) {
							if (!t.includes(n)) {
								l = !1;
								break;
							}
						} else {
							if ((t == null || t === !1) && (n == null || n === !1)) continue;
							if (n !== t) {
								l = !1;
								break;
							}
						}
					}
					l && (r && n.push(r), o && n.push(o));
				}
				return n;
			}, D = (t) => {
				let n = w(B, t);
				if (!Array.isArray(n)) return n;
				let r = {}, i = e;
				for (let e = 0; e < n.length; e++) {
					let t = n[e];
					if (typeof t == "string") r.base = i(r.base, t)(N);
					else if (typeof t == "object") for (let e in t) r[e] = i(r[e], t[e])(N);
				}
				return r;
			}, O = (e) => {
				if (j.length < 1) return null;
				let t = {}, n = b(null, e);
				for (let e = 0; e < j.length; e++) {
					let { slots: r = [], class: i, className: o,...l } = j[e];
					if (!x(l)) {
						let e = !0;
						for (let t in l) {
							let r = n[t], i = l[t];
							if (r === void 0 || (Array.isArray(i) ? !i.includes(r) : i !== r)) {
								e = !1;
								break;
							}
						}
						if (!e) continue;
					}
					for (let e = 0; e < r.length; e++) {
						let n = r[e];
						t[n] || (t[n] = []), t[n].push([i, o]);
					}
				}
				return t;
			};
			if (!x(E) || !L) {
				let t = {};
				if (typeof z == "object" && !x(z)) {
					let n = e;
					for (let e in z) t[e] = (t) => {
						let r = D(t), i = O(t);
						return n(z[e], _(e, t), r ? r[e] : void 0, i ? i[e] : void 0, t?.class, t?.className)(N);
					};
				}
				return t;
			}
			return e(P, l(), w(B), t?.class, t?.className)(N);
		};
		return V.variantKeys = (() => {
			if (!(!F || typeof F != "object")) return Object.keys(F);
		})(), V.extend = _, V.base = P, V.slots = z, V.variants = F, V.defaultVariants = I, V.compoundSlots = j, V.compoundVariants = B, V;
	};
	return {
		tv: t,
		createTV: (e) => (n, r) => t(n, r ? p(e, r) : e)
	};
}, f = (n) => x(n) ? twMerge : extendTailwindMerge({
	...n,
	extend: {
		theme: n.theme,
		classGroups: n.classGroups,
		conflictingClassGroupModifiers: n.conflictingClassGroupModifiers,
		conflictingClassGroups: n.conflictingClassGroups,
		...n.extend
	}
}), { createTV: C, tv: T } = le((...e) => (t) => {
	let n = u(e);
	return !n || !t.twMerge ? n : ((!S.cachedTwMerge || S.didTwMergeConfigChange) && (S.didTwMergeConfigChange = !1, S.cachedTwMerge = f(S.cachedTwMergeConfig)), S.cachedTwMerge(n) || void 0);
});
export { T as t };
